<template>
  <section style="background-size:cover; background-position:top; background-repeat:no-repeat;"
          :style="backgroundImage">
    
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark ">
      <a class="navbar-brand p-3" href="/"><img src="/images/logo.svg"><p class="logo-titulo">Parroquia del Espíritu Santo</p></a>
       
      <button v-if="isAuthenticated" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
      </button>

      <div v-if="isAuthenticated" class="collapse navbar-collapse"  id="navbarNavDropdown">
        <ul class="navbar-nav" style="margin-left: auto;">
        
          <li class="nav-item dropdown active">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Misal
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <router-link class="dropdown-item" to="/misas">Todas las misas</router-link>
              <router-link class="dropdown-item" to="/misas/agrega">Agregar misa</router-link>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" @click="logout()">Cerrar Sesión</a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="container-fluid pt-2" >
      <div class="row">
        <div class="col-12 col-lg-4 pt-5 pl-5 pr-5">
          <h1 class="text-uppercase text-light pb-5 d-none d-md-block">{{titulo}}</h1>
          <h1 class="text-uppercase text-light pb-1 d-md-none">{{titulo}}</h1>
          <h2 class="text-light">Lee el evangelio desde cualquier dispositivo.<br> Escanea el código QR y sigue misa con nosotros.</h2>
        </div>
        <div class="col-md-6 col-lg-4 col-12 p-5">
          <div class="m-auto w-100 text-center">
            <h5 class="text-light text-center text-uppercase" style="letter-spacing:4px">Liturgia <br> {{ format(date,"dddd, MMMM D YYYY") }}</h5>
            <router-link :to="URLEvangelio" class="mt-3 mb-3 btn btn-success btn-block btn-lg p-3 text-uppercase">Ir a Misa de {{fechaboton}}</router-link>
            <div class="d-md-none"><DatePicker v-model="date" autoApply :enableTimePicker="false" /></div>           
            <small class="text-light text-center d-md-none">Encuentra la lectura por fecha utilizando nuestro calendario</small>
         </div>
        </div>
       
        <div class="col-md-6 col-lg-4 col-12 p-5 d-none d-md-block">
          <div class="m-auto w-100">
            <h4 class="text-light">Encuentra la lectura por fecha utilizando nuestro calendario</h4>
            <div><DatePicker v-model="date" inline autoApply :enableTimePicker="false" /></div>
          </div>
        </div>
      </div>
    </div>
    
  </section>
</template>

<script>
import moment from 'moment';
require('moment/locale/es')
export default {
  name: 'HomeComponent',
  data(){
    return{
      date: '',
      titulo: 'Evangelio del día',
      image: 'iglesia.jpg',
      today: ''
    }
  },
  mounted(){
    this.date = new Date().toJSON().slice(0,10).replace(/-/g,'-');
    this.today = new Date().toJSON().slice(0,10).replace(/-/g,'-');
  },
  methods:{
    format(date,format){
      return moment(date).format(format);
    },
     logout(){
      this.$auth0.logout({ returnTo: window.location.origin });
    }
  },
  computed:{
    isAuthenticated(){
        return this.$auth0.isAuthenticated.value
    },
    URLEvangelio(){
      return '/misa'
      //return  '/misa/' + this.format(this.date,'YYYY-MM-DD');
    },
    fechaboton(){
      if(this.format(this.date,'YYYY-MM-DD') == this.format(this.today,'YYYY-MM-DD')){
        return 'Hoy'
      }else{
        return this.format(this.date,"dddd, MMMM D ")
      }
    },
    backgroundImage(){
      return `background-image: linear-gradient( rgba(0,0,0,.3), rgba(0,0,0,.5) ),url("./images/${this.image}")`;
    }
  }
}
</script>
